import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { useListReviewEventsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewEvents',
  props: {
    reviewRequestId: null,
    ventureId: null
  },
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var props = __props;
    var _ref2 = getCurrentInstance(),
      proxy = _ref2.proxy;
    var showCompanyColumn = computed(function () {
      return !props.ventureId;
    });
    var options = ref({
      page: 1,
      itemsPerPage: 10
    });
    var filters = computed(function () {
      return _objectSpread({
        reviewRequestId: props.reviewRequestId
      }, props.ventureId ? {
        ventureId: props.ventureId
      } : {});
    });
    var variables = computed(function () {
      return {
        filters: filters.value,
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage
      };
    });
    var _useListReviewEventsQ = useListReviewEventsQuery(variables, computed(function () {
        return {
          enabled: Boolean(props.reviewRequestId),
          fetchPolicy: 'cache-and-network'
        };
      })),
      result = _useListReviewEventsQ.result,
      loading = _useListReviewEventsQ.loading,
      refetch = _useListReviewEventsQ.refetch;
    watch(function () {
      return [props.reviewRequestId, props.ventureId];
    }, function () {
      options.value.page = 1;
    });
    var items = computed(function () {
      var _result$value$listRev, _result$value;
      return (_result$value$listRev = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listReviewEvents) !== null && _result$value$listRev !== void 0 ? _result$value$listRev : [];
    });
    var itemCount = computed(function () {
      var _result$value$countRe, _result$value2;
      return (_result$value$countRe = (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.countReviewEvents) !== null && _result$value$countRe !== void 0 ? _result$value$countRe : 0;
    });
    var tableHeaders = computed(function () {
      var headers = [];
      if (showCompanyColumn.value) {
        headers.push({
          text: proxy.$t('company'),
          value: 'venture.name',
          class: 'review-table-th'
        });
      }
      headers.push({
        text: proxy.$t('event'),
        value: 'eventType',
        class: 'review-table-th',
        width: '180px'
      }, {
        text: proxy.$t('comment'),
        value: 'comment',
        class: 'review-table-th'
      }, {
        text: proxy.$t('reviewer'),
        value: 'reviewer',
        class: 'review-table-th',
        width: '220px'
      }, {
        text: proxy.$t('reviewedAt'),
        value: 'createdAt',
        class: 'review-table-th',
        width: '168px'
      });
      return headers;
    });
    var eventStatus = function eventStatus(eventType) {
      return eventType === 'APPROVED' ? 'APPROVED' : 'EDITS_REQUESTED';
    };
    var formatDate = function formatDate(value) {
      if (!value) {
        return '—';
      }
      return new Date(value).toLocaleString();
    };
    expose({
      refetch: refetch
    });
    return {
      __sfc: true,
      props: props,
      proxy: proxy,
      showCompanyColumn: showCompanyColumn,
      options: options,
      filters: filters,
      variables: variables,
      result: result,
      loading: loading,
      refetch: refetch,
      items: items,
      itemCount: itemCount,
      tableHeaders: tableHeaders,
      eventStatus: eventStatus,
      formatDate: formatDate
    };
  }
});